export function registerServiceWorker(): void {
  if (!("serviceWorker" in navigator)) {
    return;
  }

  // На iOS SW не нужен для «На экран Домой» и иногда мешает Safari.
  if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
    return;
  }

  const isSecure =
    window.location.protocol === "https:" ||
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  if (!isSecure) {
    return;
  }

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL || ""}/sw.js`, { scope: "/" })
      .catch(() => {});
  });
}
